import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

export default (el, props) => {
    const dom = $(el);
    const body = $('body');
    const images = dom.find('[data-product-images]').find('figure');
    const modalTrigger = dom.find('[data-gallery-trigger]');

    let flkty;
    let navButton;
    let modal;
    let gallery;
    let indexNumber = 1;
    let hasSlideshow = false;
    let hasModal = false;
    let closeButton;
    let indexHolder;

    function onNavClick() {
        if ($(this).data('slider-nav') === 'next') {
            flkty.next();
        } else {
            flkty.previous();
        }
    }

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (key === 39) {
            flkty.next();
        }

        if (key === 37) {
            flkty.previous();
        }

        if (key === 27) {
            closeModal(null);
        }
    };

    const closeModal = e => {
        if (e) {
            e.preventDefault();
        }

        if (hasModal) {
            TweenMax.to(modal.get(0), 0.5, { opacity: 0, clearProps: 'all' });
            document.removeEventListener('keyup', keyup);
        }
    };

    const initModal = () => {
        hasModal = true;
        body.append('<div class="product-gallery t-anti l-pos-fix l-fill" data-product-modal><div class="product-gallery__outer l-pos-abs l-fill" data-product-modal-outer></div></div>');
        modal = $('[data-product-modal]');

        TweenMax.set(modal.get(0), { display: 'block' });

        const modalInner = modal.find('[data-product-modal-outer]');

        modalInner.append('<div class="product-gallery__inner l-pos-rel" data-product-gallery></div>');

        modalInner.append(`
            <div class="product-gallery__header l-pos-abs t-h-9">
                <div class="l-wrap">
                    <div class="l-pos-rel">
                        <div class="product-gallery__title">
                            <span class="t-serif t-italic">${dom.find('[data-heading]').html()}</span> - <span data-index>${indexNumber}</span> av ${images.length} bilder
                        </div>
                        <a href="#top" class="product-gallery__close l-pos-abs l-ib" data-product-modal-close>
                            <span class="product-gallery__close-text">Lukk gallerivisning</span>
                            <span class="product-gallery__close-icon"><span></span><span></span></span>
                        </a>
                    </div>
                </div>
            </div>`);

        indexHolder = modal.find('[data-index]');

        modalInner.append('<button type="button" name="button" aria-label="Neste bilde" class="product-gallery__nav product-gallery__nav--next slider__button l-ib" data-slider-nav="next"><span class="product-gallery__nav-text">Neste</span><span class="icon-arrow l-block l-pos-abs"></span></button>');

        modalInner.append('<button type="button" name="button" aria-label="Forrige bilde" class="product-gallery__nav product-gallery__nav--prev slider__button l-ib" data-slider-nav="prev"><span class="product-gallery__nav-text">Forrige</span><span class="icon-arrow icon-arrow--left l-block l-pos-abs"></span></button>');

        navButton = modal.find('[data-slider-nav]');
        closeButton = modal.find('[data-product-modal-close]');

        gallery = modal.find('[data-product-gallery]');
        gallery.append(images.clone());
        gallery.find('figure').wrap('<div class="product-gallery__slide l-pos-abs l-fill" data-gallery-slide></div>');
        gallery.find('img').addClass('l-objectfit l-objectfit--contain').each(img => {
            const $img = $(img);
            const modalSrcset = $img.attr('data-srcset-modal');
            console.log(modalSrcset);
            if (modalSrcset) {
                if ($img.hasClass('lazyload')) {
                    $img.attr('data-srcset', modalSrcset);
                } else {
                    $img.removeClass('lazyloaded').addClass('lazyload');
                    $img.attr('data-srcset', modalSrcset);
                    $img.attr('srcset', modalSrcset);
                }
            }
        });
        gallery.find('picture').attr({ class: null, style: null });
        gallery.find('figcaption span').removeClass('t-serif', 't-italic');



        closeButton.on('click', closeModal);
        window.lazySizes.autoSizer.checkElems();
        initSlideshow();
        showModal();
    };

    const initSlideshow = () => {
        hasSlideshow = true;

        flkty = new Flickity(gallery.get(0), {
            cellSelector: '[data-gallery-slide]',
            wrapAround: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            dragThreshold: 10,
            cellAlign: 'center',
            setGallerySize: false,
            percentPosition: true,
            accessibility: true,
            initialIndex: indexNumber - 1
        });

        navButton.on('click', onNavClick);

        flkty.on('select', () => {
            indexHolder.html(flkty.selectedIndex + 1);
        });
    };

    const showModal = () => {
        TweenMax.set(modal.get(0), { display: 'block' });
        flkty.resize();
        TweenMax.to(modal.get(0), 0.5, { opacity: 1 });
        document.addEventListener('keyup', keyup);
    };

    function onTriggerClick(e) {
        e.preventDefault();
        indexNumber = parseInt($(this).data('gallery-trigger'), 10);
        if (!hasModal) {
            initModal();
        } else {
            flkty.select(indexNumber - 1, false, true);
            indexHolder.html(indexNumber);
            showModal();
        }
    };

    const init = () => {
        modalTrigger.on('click', onTriggerClick);
    };

    const destroy = () => {
        if (hasSlideshow) {
            flkty.destroy();
            navButton.on('click', onNavClick);
        }

        if (hasModal) {
            closeButton.off('click', closeModal);
            modal.remove();
        }

        hasSlideshow = false;
        hasModal = false;
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Product.js